import HighlightCard from '../../../Components/HighlightCard/HighlightCard';
import styles from './home.module.scss';
import sectionList from '../../../Data/Sections.json';
import Footer from '../../../Components/Footer/Footer';
import { useNavigate } from 'react-router-dom';
import useInView from '../../../Components/UseInView/useInView';

const Home = () => {
    const navigate = useNavigate();
    const [sloganRef, sloganVisible] = useInView();

    let sectionRender = sectionList.map((item) => {
        return (
            <HighlightCard
                key={item.brand}
                brand={item.brand}
                imgLink={item.imgLink}
                onClick={() => navigate(`/${item.id}`)}
            />
        );
    });

    return (
        <>
            <div className={styles.placeholder} />
            <div className={styles.landingPage}>
                <img
                    src={
                        'https://plus.unsplash.com/premium_photo-1664202525979-80d1da46b34b?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
                    }
                    alt='landing'
                />
                <h1
                    id='Slogan'
                    ref={sloganRef}
                    className={`${sloganVisible ? styles.visible : ''}`}
                >
                    Seçilmiş Ürünler.
                    <br />
                    Gerçek Fiyatlar.
                    <br />
                </h1>
            </div>
            <div className={styles.sections}>{sectionRender}</div>
            <Footer />
        </>
    );
};

export default Home;
